module.exports = __webpack_public_path__ + "img/argendata4.8e0acaa4.jpg";